import styled from 'styled-components';
import { Delete } from '@styled-icons/material-outlined/Delete';

export const RemoveUserIcon = styled(Delete)`
  width: 1.125rem;
  margin-right: 0.25rem;
  color: ${({ theme }) => theme.colors.red2};
`;

export const RemoveItemContent = styled.div`
  cursor: pointer;
`;
